import React from 'react';
import * as lodash from 'lodash';
import {Button, Checkbox, message, Select, Radio } from 'antd';
const RadioGroup = Radio.Group;
import {WeaDialog, WeaSearchGroup, WeaFormItem, WeaInput, WeaSelect, WeaBrowser, WeaCheckbox, WeaHelpfulTip} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EField_New from './base/EField_New';
import EOrderCol from './base/EOrderCol';
import EPicturesSettings from './base/EPicturesSettings';
import './Style_7.css';
// 文档中心，数据来源
class Content_7_DataSource extends React.Component {

    state = {
        id: this.props.tabData.id,
        title: this.props.tabData.title || '',
        topDocs: this.props.tabData.topDocs,
        docSourceType: this.props.tabData.docSourceType || this.props.tabNew.docSourceType.selected,
        newsCenters: this.props.tabData.newsCenters,
        docCatalogs: this.props.tabData.docCatalogs,
        virtualCatalogs: this.props.tabData.virtualCatalogs,
        appointDocs: this.props.tabData.appointDocs,
        showMode: this.props.tabData.showMode || this.props.tabNew.showMode.selected,
        scrollDirection: this.props.tabData.scrollDirection || this.props.tabNew.scrollDirection.selected,
        isOpenAttachment: this.props.tabData.isOpenAttachment || this.props.tabNew.isOpenAttachment.selected,
        topDocsNames: this.props.tabData.topDocsNames,
        newsCentersNames: this.props.tabData.newsCentersNames,
        docCatalogsNames: this.props.tabData.docCatalogsNames,
        virtualCatalogsNames: this.props.tabData.virtualCatalogsNames,
        appointDocsNames: this.props.tabData.appointDocsNames,
        topStyle:this.props.tabData.topStyle || this.props.tabNew.topStyle.selected,
        eFieldNewDataSource: this.props.tabData.eFieldNewDataSource || this.props.tabNew.eFieldNewDataSource,
        eFieldNewUsedKeys: this.props.tabData.eFieldNewUsedKeys || [],
        eFieldNewVisible: false,
        pictureWidth: this.props.tabData.pictureWidth,
        pictureHeight: this.props.tabData.pictureHeight,
        widthUnit: this.props.tabData.widthUnit || 'px',
        heightUnit: this.props.tabData.heightUnit || 'px',
        autoHeight: this.props.tabData.autoHeight || false,
        orderColDataSource: lodash.isEmpty(this.props.tabData.orderColDataSource) ? this.props.tabNew.orderColDataSource : this.props.tabData.orderColDataSource,
        orderColUsedKeys: this.props.tabData.orderColUsedKeys || [],
        orderColVisible: false,
        isShowSettingShowType: this.props.tabData.isShowSettingShowType || this.props.tabNew.isShowSettingShowType,
        showType: this.props.tabData.showType|| '0',
    };

    constructor(props) {
        super(props);
        this.getButtons = this.getButtons.bind(this);
        this.onDocSourceTypeChange = this.onDocSourceTypeChange.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onChangeSize = this.onChangeSize.bind(this);
    }

    render() {
        const {title, docSourceType, showMode,scrollDirection,
            isOpenAttachment, topDocsNames, newsCentersNames, docCatalogs,
            docCatalogsNames, virtualCatalogsNames, topStyle,
            appointDocsNames, eFieldNewVisible, eFieldNewDataSource,
            pictureWidth = '120', pictureHeight = '108',
            widthUnit, heightUnit, autoHeight, orderColDataSource,
            orderColUsedKeys, orderColVisible, isShowSettingShowType
        } = this.state;
        const {eFieldNewUsedKeys} = this.state;
        const {tabNew} = this.props;
        const type = {newsCenters: 'docnews', docCatalogs: 'doccategory', virtualCatalogs: 'docdummy', appointDocs: 37};
        const isMultCheckbox = {newsCenters: true, docCatalogs: true, virtualCatalogs: true, appointDocs: true};
        const replaceDatas = {newsCenters: newsCentersNames, docCatalogs: docCatalogsNames, virtualCatalogs: virtualCatalogsNames, appointDocs: appointDocsNames};
        let EFieldNew = <div></div>;
        if (eFieldNewVisible) {
            const eFieldNewProps = {
                eFieldNewDataSource: _.cloneDeep(eFieldNewDataSource),
                eFieldNewUsedKeys: _.cloneDeep(eFieldNewUsedKeys),
                onOk: (data) => {
                    this.setState({
                        eFieldNewDataSource: _.cloneDeep(data.eFieldNewDataSource),
                        eFieldNewUsedKeys: _.cloneDeep(data.eFieldNewUsedKeys),
                        eFieldNewVisible: false
                    });
                },
                onCancel: () => {
                    this.setState({
                        eFieldNewVisible: false
                    });
                }
            };
            EFieldNew = <EField_New {...eFieldNewProps}/>
        }

        const eFieldNewUsedNames = [];
        for (let i = 0; i < eFieldNewUsedKeys.length; i++) {
            for (let j = 0 ; j < eFieldNewDataSource.length; j++) {
                if (eFieldNewUsedKeys[i] == eFieldNewDataSource[j].key) {
                    eFieldNewUsedNames.push(eFieldNewDataSource[j].name);
                }
            }
        }

        let orderColComp = <div></div>;
        if (orderColVisible) {
            const orderColProps = {
                orderColDataSource: _.cloneDeep(orderColDataSource),
                orderColUsedKeys: _.cloneDeep(orderColUsedKeys),
                onOk: (data) => {
                    this.setState({
                        orderColDataSource: data.orderColDataSource,
                        orderColUsedKeys: data.orderColUsedKeys,
                        orderColVisible: false
                    });
                },
                onCancel: () => {
                    this.setState({
                        orderColVisible: false
                    });
                }
            };
            orderColComp = <EOrderCol {...orderColProps}/>
        }

        const orderColUsedNames = [];
        for (let i = 0, len = orderColUsedKeys.length; i < len; i++) {
            for (let j = 0, len2 = orderColDataSource.length; j < len2; j++) {
                if (orderColUsedKeys[i] == orderColDataSource[j].key) {
                    orderColUsedNames.push(orderColDataSource[j].fieldName + '-' + (orderColDataSource[j].orderType == '0' ? getLabel(340,'降序') : getLabel(339,'升序')));
                }
            }
        }

        let authoHeight = (autoHeight ? "portal-news-authoheight" : '') ;
        const radioStyle = {
            display: 'inline-block',
            height: '30px',
            lineHeight: '30px',
            position: 'relative'
        };
        return (
            <WeaDialog
                className="portal-esetting-dialog portal-news-esetting-dialog"
                visible={true}
                title={getLabel(19480, '内容设置')}
                icon="icon-coms-portal"
                iconBgcolor='#1a57a0'
                style={{width: 660, height: 507}}
                hasScroll={true}
                buttons={this.getButtons()}
                onCancel={this.onCancel}
            >
                <WeaSearchGroup title={getLabel(33396, '设置项')} needTigger={true} showGroup={true}>
                    <WeaFormItem label={getLabel(24986, '标题')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaInput inputType="multilang" isBase64={true} value={title} viewAttr={3} onChange={value => this.setState({title: value})}/>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(507373,'标签页显示未读')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaSelect
                            options={isShowSettingShowType == '1' ? [
                                {key: '0', selected: true, showname: getLabel(23857,'不显示')},
                                {key: '1', selected: false, showname: <div>{getLabel(507374,'显示未读标记') }<WeaHelpfulTip className={'portal-news-showtype-tip'} width = {196} title={getLabel(507375,'只统计显示条数中的未读文档') } placement="bottomLeft" /></div>},
                                {key: '2', selected: false, showname: <div>{getLabel(81437,'显示未读数量') }<WeaHelpfulTip className={'portal-news-showtype-tip'} className={'AAAAAAAA'} width = {196} title={getLabel(507376,'开启后，只统计显示条数中的未读文档，且涉及跨目录统计，可能会有性能问题。') } placement="bottomLeft" /></div>},
                            ]:[
                                {key: '0', selected: true, showname: getLabel(23857,'不显示')},
                                {key: '1', selected: false, showname: <div>{getLabel(507374,'显示未读标记') }<WeaHelpfulTip className={'portal-news-showtype-tip'} width = {196} title={getLabel(507375,'只统计显示条数中的未读文档') } placement="bottomLeft" /></div>},
                            ]}
                            value={isShowSettingShowType == '0' && this.state.showType == '2' ? '0' : this.state.showType}
                            detailtype={3}
                            onChange={value => {
                                this.setState({showType: value});
                            }}
                        />
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(23784, '文档置顶')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaBrowser
                            type={37}
                            title={getLabel(386382, '请选择')}
                            isSingle={false}
                            replaceDatas={topDocsNames}
                            onChange={(ids, names, datas) => this.setState({topDocs: ids, topDocsNames: datas})}
                            layout={document.body}
                        />
                    </WeaFormItem>
                    <WeaFormItem  label={getLabel(21653, '显示方式')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <div style={{display: 'inline-block',width: '160px'}}>
                            <Select ref="fillStyleSelect" size='large'
                                    className="eStyle-7 wea-select eeStyle-7"
                                    dropdownClassName="droptwo"
                                    dropdownMatchSelectWidth={true}
                                    onChange={value => {
                                        this.setState({
                                            showMode: value,
                                            topStyle: ''
                                        });
                                    }} style={{ width: '175px' }} value={showMode}>
                                <Option className={'portal-imgSlide-images-option'} value="1">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(19525, '列表式')}>
                                        <img className="portal-imgSlide-images-style-content-image" style={{marginRight: '15px'}} src="/spa/portal/images/news/listStyle.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(19525, '列表式')}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="4">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(387382,"列表式2")}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/listStyle2.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(387382,"列表式2")}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="2">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(82760, '上图式')}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/abovePictureStyle.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(82760, '上图式')}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="10">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(82760, '上图式')+2}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/abovePictureStyle2.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(82760, '上图式')+2}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="3">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(82759, '左图式')}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/leftPictureStyle.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(82759, '左图式')}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="5">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(23804, '双列式')}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/doubleListStyle.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(23804, '双列式')}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="6">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(387383,"摘要式")}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/summaryStyle.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(387383,"摘要式")}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="7">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(387384,"摘要式2")}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/summaryStyle2.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(387384,"摘要式2")}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="8">
                                    <div className="portal-imgSlide-images-style-content-type" title={getLabel(127292, '头条式')}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/topNewsStyle.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{getLabel(127292, '头条式')}</span>
                                    </div>
                                </Option>
                                <Option className={'portal-imgSlide-images-option'} value="9">
                                    <div className="portal-imgSlide-images-style-content-type" title={'头条式2'}>
                                        <img className="portal-imgSlide-images-style-content-image" src="/spa/portal/images/news/topNewsStyle2.png" alt=""/>
                                        <span className="portal-imgSlide-images-style-content-span">{'头条式2'}</span>
                                    </div>
                                </Option>
                            </Select>
                        </div>
                        {
                            this.state.showMode =='8' || this.state.showMode =='9' || this.state.showMode =='10'?
                                <span className={'portal-new-topStyle-select'} style={{display: 'inline-block',marginLeft: '66px', width: '160px'}}>
                                <Select
                                    dropdownClassName="droptwo"
                                    dropdownMatchSelectWidth={true}
                                    className="eStyle-7 wea-select"
                                    style={{paddingTop: '0px!important',width: 175}}
                                    ref="fillStyleSelect" size='large'
                                    value={(topStyle =='' ? '1' : topStyle)}
                                    onChange={value => {
                                        this.setState({topStyle: value});
                                    }}
                                >
                                      {tabNew.topStyle.options.map(d => <Option value={d.key}>{d.showname}</Option>)}
                                </Select>
                            </span>
                                : ''
                        }
                    </WeaFormItem>
                    {
                        showMode == '6' || showMode == '7' ? ''
                            : <WeaFormItem label={getLabel(19495, '显示字段')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                                {EFieldNew}
                                <div style={{height: '100%', lineHeight: '23px'}}>
                                    <i className="icon-coms-Flow-setting portal-esetting-btn"
                                       style={{position: "relative", zIndex: "12",top:5}}
                                       onClick={() => this.setState({eFieldNewVisible: true})}/>
                                    <div
                                        title={eFieldNewUsedNames.join('，')} style={{marginTop:-18,"-webkit-line-clamp": 2,
                                        "-webkit-box-orient": "vertical",    "cursor": "pointer"}}>&nbsp;&nbsp;&nbsp;&nbsp;{eFieldNewUsedNames.join('，')}</div>
                                </div>
                            </WeaFormItem>
                    }
                    <WeaFormItem label={getLabel(15512, '排序字段')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        {orderColComp}
                        <div style={{height: '100%', lineHeight: '23px'}}>
                            <i className="icon-coms-Flow-setting portal-esetting-btn"  style={{position: "relative", zIndex: "12",top:5}} onClick={() => this.setState({orderColVisible: true})}/>
                            <div  title={orderColUsedNames.join('，')}  style={{marginTop:-18,"-webkit-box-orient": "vertical","cursor": "pointer","-webkit-line-clamp": 2,}}>&nbsp;&nbsp;&nbsp;&nbsp;{orderColUsedNames.join('，')}</div>
                        </div>
                    </WeaFormItem>
                    {
                        this.state.showMode == '1' || this.state.showMode == '5' || this.state.showMode == '8' ? ''
                            :<EPicturesSettings onChangeSize={this.onChangeSize} pictureWidth={pictureWidth} widthUnit={widthUnit} authoHeight={authoHeight} autoHeight={autoHeight} pictureHeight={pictureHeight} heightUnit={heightUnit}/>
                    }
                    <WeaFormItem label={getLabel(20281, '滚动方向')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                       <span className={'portal-new-topStyle-select'} style={{display: 'inline-block', width: '160px'}}>
                            <Select
                                dropdownClassName="dropcdone"
                                dropdownMatchSelectWidth={true}
                                className="eStyle-7 wea-select "
                                ref="fillStyleSelect" size='large'
                                style={{paddingTop: '0px!important',width: 160,}}
                                value={scrollDirection}
                                onChange={value => {
                                    this.setState({scrollDirection: value});
                                }}

                            >
                                {tabNew.scrollDirection.options.map(d => <Option value={d.key}>{d.value}</Option>)}
                            </Select>

                                </span>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(20895, '直接打开附件')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <div style={{display: 'inline-block', width: '45px',"line-height": 27,
                            height: 27}}>
                            <WeaCheckbox
                                value={isOpenAttachment}
                                display="switch"
                                id='test'
                                style={{display: 'inline'}}
                                onChange={value => {
                                    this.setState({isOpenAttachment: value});
                                }}
                            />
                        </div>
                        <WeaHelpfulTip
                            width = {196} //如果要自定义宽度，在这里设置
                            title={getLabel(20896, '当文档内容为空，且此文档仅有一个附件时')}
                        />
                    </WeaFormItem>
                </WeaSearchGroup>
                <WeaSearchGroup title={getLabel(127253, '来源设置')} showGroup={true} center={true}>
                    {
                        tabNew.docSourceType.options.map((item, index) => {
                            let dataParams = {};
                            const _type = item.type;
                            if('docCatalogs' == _type) dataParams = {filtercategoryid:docCatalogs, filtertype:3,noAllDirName:'1'};
                            else dataParams ={};
                            const _typeNames = item.type + 'Names';
                            return (
                                <div style={{position: 'relative', padding: '8px 0'}}>
                                    <Checkbox
                                        key={index}
                                        checked={lodash.indexOf(docSourceType.split(','), item.value) != -1}
                                        style={{position: 'absolute', top: '14px', left: -26, width: '100px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                                        onChange={(e) => this.onDocSourceTypeChange(item.value, e.target.checked)}
                                    >
                                        <span title={item.label}>{item.label}</span>
                                    </Checkbox>
                                    <div style={{paddingLeft: 121, width: 507}}>
                                        <WeaBrowser
                                            title={getLabel(386382, '请选择')}
                                            type={type[_type]}
                                            dataParams={dataParams}
                                            isSingle={false}
                                            replaceDatas={replaceDatas[_type]}
                                            onChange={(ids, names, datas) => {
                                                this.setState({[_type]: ids, [_typeNames]: datas});
                                                if(ids != ''){
                                                    this.onDocSourceTypeChange(item.value, true)
                                                }
                                            }}
                                            layout={document.body}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    }
                </WeaSearchGroup>
            </WeaDialog>

        );
    }

    getButtons() {
        let buttons = [];
        buttons.push(<Button type="primary" onClick={this.onOk}>{getLabel(826, '确定')}</Button>);
        buttons.push(<Button type="ghost" onClick={this.onCancel}>{getLabel(31129, '取消')}</Button>);
        return buttons;
    }

    onChangeSize(string,value){
        this.setState({
            [string]: value
        })
    }

    onDocSourceTypeChange(value, checked) {
        const {docSourceType} = this.state;
        const docSourceTypeArr = docSourceType.split(',');

        lodash.pull(docSourceTypeArr, value);
        if (checked) {
            docSourceTypeArr.push(value);
        }

        this.setState({docSourceType: docSourceTypeArr.join(',')});
    }

    onOk() {
        if (!this.state.title) {
            message.warning(getLabel(15859, '必要信息不完整！'));
        } else {
            const {orderColDataSource:ds, orderColUsedKeys:keys, showMode} = this.state;

            const orderColUsed = [];
            for (let i = 0, len = keys.length; i < len; i++) {
                for (let j = 0, len2 = ds.length; j < len2; j++) {
                    if (keys[i] == ds[j].key) {
                        orderColUsed.push(ds[j]);
                    }
                }
            }
            if(showMode == '6' || showMode == '7'){
                this.props.onOk({...this.state, orderColUsed,eFieldNewUsedKeys: ["7","10","11"]});
            }else this.props.onOk({...this.state, orderColUsed});

        }
    }

    onCancel() {
        this.props.onCancel();
    }
}

export default Content_7_DataSource;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_7_DataSource.js